// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold } from "@fdr/static-ui/Typography";

export const PayoffsTable = styled.ul`
  width: 100%;
  position: relative;
  background-color: ${buildColor("white", "100")};
`;

export const PayoffsTitle = styled.h1`
  font-size: 18px;
  font-family: ${fontBold};
  font-weight: 500;
  color: ${buildColor("navy", "700")};
  padding: 12px 0 12px 16px;
  width: 100%;
  margin-top: 8px;
  box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};
`;

export default PayoffsTable;
